/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
// utils
import { generateClasses } from 'utils/generators';
// material
import Icon from 'material/graphic/icon/icon';
import Group from 'material/group/group';
// styles
import styles from 'material/message/notification/notification_styles';
import injectSheet from 'react-jss';
// Blob that needs to be passes through displayMessage call:
// id is automatically generated in messageStatus reducer
// {
//     type: 'notification', //toaster, notification
//     close: true, //bool to render x button or not
//     variant: 'primary', //i.e primary, secondary - determines color
//     time: 3000, //integer in milliseconds to represent how long before component is killed
//     align: 'top-left', //top-left, top-right, bottom-left, bottom-right position to be rendered
//     icon: 'bullhorn', //icon keyword to render icon
//     title: 'Urgent', //bold text before semi colon
//     text: 'You havent agreed to this form', //message text can be html or a string
//     handleClick: null //callback
// }

/* ========== ~~~~~~~~~~ NOTIFICATION : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Notification extends Component{
    constructor(props) {
        super(props);
        this.timeout = null;
    }
    componentDidMount(){
        if(!!this.props.time) {
            this.timeout = setTimeout(() => {
                this.props.removeMessage(this.props.id, this.props.type, this.props.align);
                clearTimeout(this.timeout)
            }, this.props.time)
        }
    };
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }
    renderCloseButton = () => {
        return this.props.close ? <span onClick={this.handleClick}><Icon name={'times'} /></span> : null;
    };
    handleClick = () => {
        this.props.removeMessage(this.props.id, this.props.type, this.props.align);
        if (this.props.handleClick !== null) { this.props.handleClick(); }
    };
    render(){
        return(
            <div className={`message notification ${generateClasses(this.props)} ${this.props.classes.notification}`}>
                <Group name={`icon-text`}>
                    <Icon name={`${this.props.icon} notification-icon`} />
                    <p className={`title-text`} >{this.props.title && <strong className={`title`} >{this.props.title}:</strong>}{this.props.text}</p>
                </Group>
                {this.renderCloseButton()}
            </div>
        )
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Notification);